import visaCard from 'payment-icons/min/flat/visa.svg';
import masterCard from 'payment-icons/min/flat/mastercard.svg';
import amexCard from 'payment-icons/min/flat/amex.svg';
import discoverCard from 'payment-icons/min/flat/discover.svg';
import jcbCard from 'payment-icons/min/flat/jcb.svg';
import dinersCard from 'payment-icons/min/flat/diners.svg';
import defaultCard from 'payment-icons/min/flat/default.svg';

export const getCardImageByName = (name: string) => {
  switch (name.toLowerCase()) {
    case 'visa':
    case 'visacorporate':
      return visaCard;

    case 'mastercard':
    case 'master':
      return masterCard;

    case 'amex':
    case 'americanexpress':
      return amexCard;

    case 'discover':
    case 'discovercard':
      return discoverCard;

    case 'jcb':
      return jcbCard;

    case 'diners':
      return dinersCard;

    default:
      return defaultCard;
  }
};

const firstDigitToCardImage = {
  '4': visaCard,
  '5': masterCard,
  '6': discoverCard,
  '3': amexCard,
};

export const getCardImageByBin = (bin: number | string) => {
  const image = firstDigitToCardImage[String(bin)[0]];

  return image || defaultCard;
};
